import { render, staticRenderFns } from "./PartialLeadHistoryFeeling.vue?vue&type=template&id=36d83eb0&scoped=true&"
import script from "./PartialLeadHistoryFeeling.vue?vue&type=script&lang=js&"
export * from "./PartialLeadHistoryFeeling.vue?vue&type=script&lang=js&"
import style0 from "./PartialLeadHistoryFeeling.vue?vue&type=style&index=0&id=36d83eb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d83eb0",
  null
  
)

export default component.exports